import { useMemo } from 'react'
import {
  MarketLanguages,
  deriveMarketLanguages
} from '../../modules/Audience/audienceLanguages'
import { useFieldwork } from '../useFieldwork'

/**
 * The current market/survey's display languages, derived from its fieldwork
 * language allocations (see {@link deriveMarketLanguages}). Used to drive the
 * audience builder's language switch and to determine the default (primary)
 * display language.
 */
export const useMarketLanguages = (): MarketLanguages => {
  const { fieldwork } = useFieldwork()
  return useMemo(
    () =>
      deriveMarketLanguages(
        fieldwork?.languageAllocations,
        fieldwork?.locale.language
      ),
    [fieldwork]
  )
}
